import { useMemo } from 'react';

import { useQueryListDistributionChannel } from './useQuery';

import { DistributionChannel, RECORD_STATUS } from '~types';

export const useGetDistributionChannelOptions = () => {
  const { data: distributionData } = useQueryListDistributionChannel({
    page: 0,
    size: 20,
    status: RECORD_STATUS.ACTIVE,
  });

  const distributionChannelOptions = useMemo<DistributionChannel[]>(() => {
    if (!distributionData?.data) return [];
    return distributionData.data.map(({ id, name }) => ({ id, name }));
  }, [distributionData?.data]);

  return {
    distributionChannelOptions,
  };
};
